import { createFeatureSelector, createSelector } from '@ngrx/store';

import { LoaderState } from '../reducers/loader.reducer';

export const selectLoaderState = createFeatureSelector<LoaderState>('loader');
export const selectGlobalLoader = createSelector(selectLoaderState, ({globalLoader}) => globalLoader);
